import { IRpaConnectBluePrismState } from 'app/rpa-bots/core/IRpaBots';
import { EBluePrismConnActions, BluePrismConnActions } from '../actions/rpa-blueprism-conn.actions';

export const initialStateRpaBluePrismState: IRpaConnectBluePrismState = {
    isLoadingList: false,
    isLoadingDetail: false,
    connectors: [],
    currentConnector: null
}

export function RpaBluePrismReducers(state = initialStateRpaBluePrismState, action: BluePrismConnActions): IRpaConnectBluePrismState {
    switch (action.type) {

        case EBluePrismConnActions.BluePrismConnList: {
            const newState: IRpaConnectBluePrismState = {
                ...state,
                isLoadingList: true
            };
            return newState;
        }

        case EBluePrismConnActions.BluePrismConnListSuccess: {
            const newState: IRpaConnectBluePrismState = {
                ...state,
                isLoadingList: false,
                connectors: _.orderBy([...action.payload], (p) => p.name)
            };
            return newState;
        }

        case EBluePrismConnActions.getCurrentBluePrismConn: {
            const newState: IRpaConnectBluePrismState = {
                ...state,
                isLoadingDetail: true
            }
            return newState;
        }

        case EBluePrismConnActions.getCurrentBluePrismConnSuccess: {
            const newState: IRpaConnectBluePrismState = {
                ...state,
                isLoadingDetail: false,
               currentConnector:  { ...action.payload }
            }
            return newState;
        }

        case EBluePrismConnActions.UpdateBluePrismConn: {
            const newState: IRpaConnectBluePrismState = {
                ...state,
                isLoadingDetail: true
            }
            return newState;
        }

        case EBluePrismConnActions.UpdateBluePrismConnSuccess: {
            const newState: IRpaConnectBluePrismState = {
                ...state,
                isLoadingDetail: false
            }
            return newState;
        }

        case EBluePrismConnActions.TestBluePrismConn: {
            const newState: IRpaConnectBluePrismState = {
                ...state,
                isLoadingDetail: true
            }
            return newState;
        }

        case EBluePrismConnActions.TestBluePrismConnSuccess: {
            const newState: IRpaConnectBluePrismState = {
                ...state,
                isLoadingDetail: false
            }
            return newState;
        }

        case EBluePrismConnActions.ResetBluePrismState: {
            return initialStateRpaBluePrismState;
        }

        default: {
            return state;
        }
    }
}
